function fn_comp_homepage() {
    var $fn = $(".comp_homepage");

    if($fn.length) {
        $fn.on("click","[data-scroll]",function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $($fn.find(".elm_hp_block")).offset().top - $("#layout_header").height()
            }, 1000);
        });

        var $map = $fn.find(".elm_map");

        function fn_part_filter_map() {
            $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCyz1X9wcuSt-RRCDCvAypsZOSj7-hoOQc")
                .done(function () {
                    $map.nl_google_map('init');
                    $map.nl_google_map('markers_add');
                    $map.nl_google_map("marker_click",0);
                });
        }
        fn_part_filter_map();
    }
}